var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text } from 'react-native';
// This module was needed for web to converting react-native style to css style. Some of css style need a default unit. E.g line-hight need "px" unit for the web.
// Since this component do not use the <Text> Component from the RN  but using the React.createElement approaach, so we need to manually convert the style to match the html elm style.
// We directly use the react-native-web utility.
// eslint-disable-next-line
import createReactDOMStyle from 'react-native/dist/exports/StyleSheet/createReactDOMStyle';
import PropTypes from 'prop-types';
import convert from 'htmr';
import merge from 'lodash/merge';
import { withTheme } from '../../theme';
import { tagStyles, themeStyle } from './customBaseStyle';
class DRNHtmlText extends React.Component {
    constructor() {
        super(...arguments);
        this.convertWithTheme = (htmlText, transform) => {
            // Add theme tag on top of htmlText
            const themedHtmlText = `<theme>${htmlText}</theme>`;
            const theme = (_a) => {
                var { children } = _a, rest = __rest(_a, ["children"]);
                return (<Text style={[themeStyle(this.props.theme), this.props.style]}>{children}</Text>);
            };
            return convert(themedHtmlText, { transform: Object.assign({}, transform, { theme }) });
        };
    }
    render() {
        const { htmlStyles, htmlText, theme } = this.props;
        const textStyle = merge(tagStyles(theme), htmlStyles);
        const transform = Object.keys(textStyle).reduce((prev, cur) => {
            prev[cur] = (_a) => {
                var { children, style } = _a, rest = __rest(_a, ["children", "style"]);
                const mergedStyle = Object.assign({}, textStyle[cur], style);
                return React.createElement(cur, Object.assign({ style: createReactDOMStyle(mergedStyle) }, rest), children);
            };
            return prev;
        }, {});
        return this.convertWithTheme(htmlText, transform);
    }
}
DRNHtmlText.propTypes = {
    htmlText: PropTypes.string.isRequired,
    htmlStyles: PropTypes.object,
    style: PropTypes.object,
    theme: PropTypes.object,
};
DRNHtmlText.defaultProps = {
    htmlStyles: {},
};
export default withTheme(DRNHtmlText);
